import React, { Component, Fragment } from 'react'
import Img from 'react-image'
import VisibilitySensor from 'react-visibility-sensor'

import placeholder from '../../assets/productplaceholder.png'

import { Container, ImageContainer, Title, InputContainer, ProductCode, OrderAmount, TitleContainer } from './styles'

// import ProductPopup from '../ProductPopup/'
import OrderInput from '../OrderInput/'
import Loader from '../Loader/'

class Product extends Component {
  constructor(props) {
    super(props)
    this.state = {
      popupActive: false,
      isVisible: false
    }
  }

  buttonClick(e) {
    if (e.currentTarget.dataset.amount === 'plus') {
      this.props.addToOrder(this.props.product.id)
    } else if (e.currentTarget.dataset.amount === 'min') {
      this.props.removeFromOrder(this.props.product.id)
    }
  }

  openPopup(e) {
    if (!this.state.popupActive) {
      this.setState({ popupActive: true })
    }
  }

  closePopup(e) {
    this.setState({ popupActive: false })
  }

  onChange(isVisible) {
    if (!this.state.isVisible) {
      this.setState({ isVisible })
    }
  }

  render() {
    const { product, order, wholeOrder } = this.props

    try {
      product.thumbnail = require(`../../assets/products/images/${product.productCode}/1.jpg`)
    } catch (e) {
      product.thumbnail = placeholder
    }

    let orderPart = ''
    if (this.props.editOrder) {
      let currentOrder = this.props.wholeOrder
      const index = currentOrder.orderParts.findIndex(orderPart => orderPart.product.id === this.props.product.id)
      orderPart = currentOrder.orderParts[index]
    }
    return (
      <Container>
        <ProductCode>nr. {product.productCode}</ProductCode>
        <VisibilitySensor onChange={this.onChange.bind(this)}>
          <ImageContainer>
            {this.state.isVisible ? (
              <Img
                src={product.thumbnail}
                loader={<Loader from="0%" to="100%" />}
                unloader={<img alt="product" src={placeholder} />}
              />
            ) : (
              <div />
            )}
          </ImageContainer>
        </VisibilitySensor>
        <TitleContainer>
          <Title dangerouslySetInnerHTML={{ __html: product.firstDescription }} />
        </TitleContainer>

        {this.props.editOrder && orderPart ? (
          <Fragment>
            {this.props.servicePackage !== 'Ontzorg' ? (
              <InputContainer>
                <OrderInput
                  handleClick={this.buttonClick.bind(this)}
                  product={product}
                  order={order}
                  orderPart={orderPart}
                  wholeOrder={wholeOrder}
                />
              </InputContainer>
            ) : (
              <OrderAmount>{order} st.</OrderAmount>
            )}
          </Fragment>
        ) : null}
        {/* {this.state.popupActive ? (
          <ProductPopup
            product={product}
            order={order}
            setOrderAmount={this.props.setOrderAmount}
            buttonClick={this.buttonClick.bind(this)}
            closePopup={this.closePopup.bind(this)}
          />
        ) : null} */}
      </Container>
    )
  }
}

export default Product



// WEBPACK FOOTER //
// ./src/components/Product/index.js